import Axios from '../config/axios';

export function modifyCertifications(postdata) {
    return Axios.post(`/api/ModifyCertifications`, postdata
    ).then(response => response.data).catch(error => error);
}